var React = require('react');

function TimelinePoint (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.2007 1L23 11.4916L17.2007 21.986L1 22L1.02096 1H17.2007Z","stroke":"#FF6600","strokeWidth":"2"}));
}

TimelinePoint.defaultProps = {"width":"27","height":"26","viewBox":"0 0 25 22","fill":"none"};

module.exports = TimelinePoint;

TimelinePoint.default = TimelinePoint;
